/* ==========================================================================
   Lumen — section-recently-viewed.js
   Renders the "Recently viewed" section from localStorage.
   Key: "lumen:recently-viewed" — JSON array of {handle,title,url,image,price},
   newest first, max 12 (the product page writes it). The section stays
   hidden when there is nothing to show. All strings are inserted via
   textContent/attributes — never innerHTML — so stored values stay inert.
   ========================================================================== */
(function () {
  'use strict';

  var STORAGE_KEY = 'lumen:recently-viewed';

  function readItems() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = JSON.parse(raw || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function safeUrl(item) {
    if (typeof item.url === 'string' && item.url.charAt(0) === '/' && item.url.charAt(1) !== '/') {
      return item.url;
    }
    return '/products/' + encodeURIComponent(String(item.handle));
  }

  function buildCard(item, placeholderTpl) {
    var card = document.createElement('a');
    card.className = 'recently-viewed__card reveal';
    card.href = safeUrl(item);

    var media = document.createElement('div');
    media.className = 'recently-viewed__media';
    if (typeof item.image === 'string' && item.image.length) {
      var img = document.createElement('img');
      img.className = 'recently-viewed__image';
      img.loading = 'lazy';
      img.alt = typeof item.title === 'string' ? item.title : '';
      img.src = item.image;
      media.appendChild(img);
    } else if (placeholderTpl) {
      media.appendChild(placeholderTpl.content.cloneNode(true));
    }
    card.appendChild(media);

    var info = document.createElement('div');
    info.className = 'recently-viewed__info';

    var title = document.createElement('span');
    title.className = 'recently-viewed__title';
    title.textContent = typeof item.title === 'string' ? item.title : '';
    info.appendChild(title);

    if (typeof item.price === 'string' && item.price.length) {
      var price = document.createElement('span');
      price.className = 'recently-viewed__price';
      price.textContent = item.price;
      info.appendChild(price);
    }

    card.appendChild(info);
    return card;
  }

  function showReveals(scope) {
    var els = scope.querySelectorAll('.reveal');
    Array.prototype.forEach.call(els, function (el, i) {
      if (!el.style.transitionDelay) el.style.transitionDelay = (i * 80) + 'ms';
    });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        Array.prototype.forEach.call(els, function (el) {
          el.classList.add('is-visible');
        });
      });
    });
  }

  function init(root) {
    if (root.getAttribute('data-rv-done') === 'true') return;
    root.setAttribute('data-rv-done', 'true');

    var grid = root.querySelector('[data-rv-grid]');
    if (!grid) return;

    var max = parseInt(root.getAttribute('data-max'), 10) || 8;
    var exclude = root.getAttribute('data-exclude');
    var placeholderTpl = root.querySelector('template[data-rv-placeholder]');

    var items = readItems()
      .filter(function (item) {
        return item && typeof item.handle === 'string' && item.handle.length && item.handle !== exclude;
      })
      .slice(0, max);

    if (!items.length) {
      /* Keep the editor's placeholder preview; hide entirely on the storefront. */
      if (!root.hasAttribute('data-design-mode')) root.hidden = true;
      return;
    }

    grid.textContent = '';
    items.forEach(function (item) {
      grid.appendChild(buildCard(item, placeholderTpl));
    });
    root.hidden = false;
    showReveals(grid);
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-recently-viewed]');
    Array.prototype.forEach.call(nodes, init);
  }

  initAll(document);

  /* Theme editor: re-init when the section re-renders. */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
